import { HelperActions } from "./HelperActions.js";
import { getDateFormatForInput } from "utils/gridHelpers.js";
import bytesToDisplayHelper from "utils/bytesToDisplayHelper.js";
import parse from "html-react-parser";
import { useUser } from "contexts/userContext/userContext.js";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useProfile } from "contexts/profileContext/profileContext.js";
import Icon from "../../../../Elements/Icon/Icon.tsx";

const SubUserTableRow = ({
  item,
  currentPage,
  sizeNumber,
  setLoading,
  setSubUsers,
  setNumberOfUsers,
  fieldToOrder,
  orderAscending,
}) => {
  const { getUserData } = useUser();
  const maxSize = getUserData().UserMaxStorage;
  const { getTextByKey } = useContent();
  const { getStatusFilter } = useProfile();

  const getUsedSize = (size) => {
    const percantegeOfSpace = ((size / maxSize) * 100).toFixed(2);
    let sizeWithPrecenteges = bytesToDisplayHelper(size);
    return `${sizeWithPrecenteges.size}${sizeWithPrecenteges.type} (${percantegeOfSpace}%)`;
  };

  return !getStatusFilter()?.includes("removed") ? (
    <>
      <div className="sub-user-table-desktop-row-item picture">
        {item?.ProfilePicture && parse(item.ProfilePicture)}
      </div>
      <div>
        <Tooltip
          id={item.Email}
          tooltipTextKey={`${item.ExternalSource || "jumbomail"}-account`}
          top
        >
          <Icon name={item.ExternalSource || "jumbomail-icon"} ext="png" />
        </Tooltip>
      </div>
      <div className="sub-user-table-desktop-row-item email">
        <Tooltip id={"sub-user-email"} tooltipText={item.Email} top>
          {item.Email}
        </Tooltip>
      </div>
      <div className="sub-user-table-desktop-row-item full-name">
        {item.FullName}
      </div>
      <div className="sub-user-table-desktop-row-item date">
        {item.Creation && getDateFormatForInput(item.Creation)}
      </div>
      <div className="sub-user-table-desktop-row-item date">
        {item.LastLogin && getDateFormatForInput(item.LastLogin)}
      </div>
      <div className="sub-user-table-desktop-row-item permission">
        {getTextByKey(item.Permission)}
      </div>
      <div className="sub-user-table-desktop-row-item status">
        {getTextByKey(item.Status)}
      </div>
      <div className="sub-user-table-desktop-row-item used-storage">
        {getUsedSize(item.UsedSize)}
      </div>
      <div className="sub-user-table-desktop-row-item actions">
        <HelperActions
          details={item}
          currentPage={currentPage}
          sizeNumber={sizeNumber}
          setLoading={setLoading}
          setSubUsers={setSubUsers}
          setNumberOfUsers={setNumberOfUsers}
          fieldToOrder={fieldToOrder}
          orderAscending={orderAscending}
        />
      </div>
    </>
  ) : (
    <>
      <div>
        {item?.RemovedUserProfilePicture &&
          parse(item.RemovedUserProfilePicture)}
      </div>
      <Tooltip id={"sub-user-email"} tooltipText={item?.RemovedUserEmail} top>
        <div>{item?.RemovedUserEmail}</div>
      </Tooltip>
      <div>{item?.RemovedUserName}</div>
      <div>{item?.RemovalDate && getDateFormatForInput(item.RemovalDate)}</div>
      <Tooltip
        id={"sub-user-email"}
        tooltipText={item?.RemovedUserByEmail + " " + item?.RemovedUserByName}
        top
      >
        <div>{item?.RemovedUserByEmail + " " + item?.RemovedUserByName}</div>
      </Tooltip>
      <div>{getTextByKey("removed")}</div>
    </>
  );
};

export default SubUserTableRow;
